import { connect } from "react-redux";
import AddGate from "./viewFollowUp";
import { bindActionCreators } from "redux";
import { getFollowUpDetail } from "services/redux/sales/followUpListing/action";

const mapStateToProps = (state) => ({
  followUpDetails: state.followUpListReducer.followUpDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getFollowUpDetail,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddGate);
